import {EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {ReflexiveRestModel} from 'src/lib/reflexive-model/reflexive-rest-model';
import {ReflexiveField} from 'src/lib/reflexive-model/reflexive-field';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import {pairwise, startWith} from 'rxjs/operators';


export abstract class GeliosFieldBaseComponent implements OnInit, OnDestroy {
  @Input() fieldName: string;
  @Input() formGroup: FormGroup;
  @Input() model: ReflexiveRestModel;
  @Input() reflexiveField: ReflexiveField;
  @Output() valueChange: EventEmitter<any> = new EventEmitter();
  externalValueChangeSubscription: Subscription;

  constructor(
    protected translate: TranslateService
  ) { }
  isMultiline(): boolean {
    return !!this.reflexiveField.multiline;
  }
  getPlaceholder(): string {
    switch (typeof this.reflexiveField.placeholder) {
      case 'function':
        return this.translate.instant(this.reflexiveField.placeholder(this.formGroup));
      case 'string':
        return this.translate.instant(this.reflexiveField.placeholder);
      default:
        return '';
    }
  }

  onExternalValueChange(value) {}

  ngOnInit() {
    if (this.formGroup.controls[this.fieldName]) {
      const initialValue = this.formGroup.controls[this.fieldName].value;
      this.externalValueChangeSubscription = this.formGroup.controls[this.fieldName].valueChanges
        .pipe(
          startWith(initialValue),
          pairwise(),
        )
        .subscribe(
          ([a, b]) => {
            console.log(['geliosFieldBase onValueChange subscribe', this.fieldName, a, b]);
            if (a !== b) {
              this.onExternalValueChange(b);
            }
          }
        );
    }
  }

  ngOnDestroy() {
    if (this.externalValueChangeSubscription) {
      this.externalValueChangeSubscription.unsubscribe();
    }
  }

  onValueChange(event) {
    console.log(['geliosFieldBase onValueChange', event]);
    if (event && typeof event === 'object' && 'model' in event) {
      this.valueChange.emit({fieldName: this.fieldName, value: event.value, model: event.model});
    } else {
      this.valueChange.emit({fieldName: this.fieldName, value: event});
    }
  }
}
